import React, { FC } from 'react';
import { Box, Button, Typography } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';

export interface TeamJoinSentStepProps {
  accentColor: string;
  onContinue: () => void;
}

const TeamJoinSentStep: FC<TeamJoinSentStepProps> = ({ accentColor, onContinue }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        maxWidth: 380,
        mx: 'auto',
        py: 2,
      }}
    >
      {/* Send icon badge */}
      <Box
        sx={{
          width: 64,
          height: 64,
          borderRadius: '50%',
          backgroundColor: `${accentColor}18`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mb: 3,
        }}
      >
        <SendIcon sx={{ color: accentColor, fontSize: 28 }} />
      </Box>

      <Typography variant="h5" fontWeight={700} mb={1}>
        Request Sent!
      </Typography>
      <Typography variant="body2" color="text.secondary" mb={3} sx={{ lineHeight: 1.7 }}>
        Your request to join has been submitted. Your coach will need to approve before you&apos;re added to the team.
      </Typography>

      {/* What happens next */}
      <Box
        sx={{
          width: '100%',
          textAlign: 'left',
          p: 2,
          borderRadius: 2,
          backgroundColor: `${accentColor}10`,
          border: `1px solid ${accentColor}30`,
          mb: 4,
        }}
      >
        <Typography variant="body2" fontWeight={700} sx={{ color: accentColor, mb: 0.5 }}>
          What happens next?
        </Typography>
        <Typography variant="caption" color="text.secondary" sx={{ lineHeight: 1.6 }}>
          Your coach will receive a notification to review your request. You&apos;ll be notified once they accept.
        </Typography>
      </Box>

      <Button
        variant="contained"
        fullWidth
        onClick={onContinue}
        sx={{
          borderRadius: 999,
          py: 1.25,
          fontWeight: 600,
          fontSize: 15,
          backgroundColor: accentColor,
          boxShadow: 'none',
          '&:hover': { backgroundColor: accentColor, filter: 'brightness(0.9)', boxShadow: 'none' },
        }}
      >
        Continue
      </Button>
    </Box>
  );
};

export default TeamJoinSentStep;
